/* ============================================
   PRODUCT CARD ENHANCED - JavaScript v9 FINAL
   AJAX add to cart
   Actualiza: bubble del carrito + contenido del drawer
   NO toca: header, botones, cart-icon, layout
   ============================================ */

function pceChangeQty(btn, direction, minQty) {
  var card = btn.closest('.pce-card__qty');
  var input = card.querySelector('.pce-card__qty-input');
  var step = minQty || 1;
  var current = parseInt(input.value) || step;
  var newVal = current + (direction * step);
  if (newVal < step) newVal = step;
  input.value = newVal;
}

function pceUpdateCard(select) {
  var card = select.closest('.pce-card');
  var option = select.options[select.selectedIndex];

  var priceEl = card.querySelector('.pce-card__price');
  var comparePriceEl = card.querySelector('.pce-card__compare-price');

  if (priceEl && option.dataset.price) {
    priceEl.textContent = option.dataset.price;
  }
  if (comparePriceEl) {
    if (option.dataset.compareRaw && parseInt(option.dataset.compareRaw) > parseInt(option.dataset.priceRaw)) {
      comparePriceEl.textContent = option.dataset.comparePrice;
      comparePriceEl.style.display = '';
    } else {
      comparePriceEl.style.display = 'none';
    }
  }

  var skuEl = card.querySelector('.pce-card__sku');
  if (skuEl && option.dataset.sku) {
    skuEl.textContent = option.dataset.sku;
  }

  var atcBtn = card.querySelector('.pce-card__atc-btn');
  if (atcBtn) {
    if (option.dataset.available === 'false') {
      atcBtn.disabled = true;
      atcBtn.classList.add('pce-card__atc-btn--disabled');
    } else {
      atcBtn.disabled = false;
      atcBtn.classList.remove('pce-card__atc-btn--disabled');
    }
  }
}

/* Actualizar el numerito del carrito */
function pceUpdateBubble(count) {
  var bubble = document.querySelector('[ref="cartBubble"], .cart-bubble');
  if (!bubble) return;
  /* Poner el numero */
  var span = bubble.querySelector('span');
  if (span) {
    span.textContent = count;
  } else {
    bubble.textContent = count;
  }
  /* Mostrar el bubble */
  if (count > 0) {
    bubble.classList.remove('visually-hidden');
    bubble.removeAttribute('hidden');
  }
}

/* Refrescar SOLO el dialog del cart drawer */
function pceRefreshDrawer() {
  /* Encontrar el section ID que contiene el cart-drawer */
  var drawerEl = document.querySelector('cart-drawer-component');
  if (!drawerEl) return Promise.resolve();

  var section = drawerEl.closest('[id^="shopify-section-"]');
  if (!section) return Promise.resolve();

  var sectionId = section.id.replace('shopify-section-', '');

  return fetch(window.location.pathname + '?sections=' + sectionId)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var html = data[sectionId];
      if (!html) return;

      /* Parsear el HTML nuevo */
      var parsed = new DOMParser().parseFromString(html, 'text/html');

      /* Extraer SOLO el dialog del HTML nuevo */
      var newDialog = parsed.querySelector('cart-drawer-component dialog');
      var currentDialog = drawerEl.querySelector('dialog');

      if (newDialog && currentDialog) {
        currentDialog.innerHTML = newDialog.innerHTML;
        /* Copiar atributos importantes */
        Array.from(newDialog.attributes).forEach(function(attr) {
          currentDialog.setAttribute(attr.name, attr.value);
        });
      }

      /* Tambien actualizar el template de carrito vacio si existe */
      var newTemplate = parsed.querySelector('cart-drawer-component template');
      var currentTemplate = drawerEl.querySelector('template');
      if (newTemplate && currentTemplate) {
        currentTemplate.innerHTML = newTemplate.innerHTML;
      }
    })
    .catch(function() {});
}

/* Interceptar submit */
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.hasAttribute('data-pce-form')) return;

  e.preventDefault();

  var btn = form.querySelector('.pce-card__atc-btn');
  if (!btn || btn.disabled) return;

  var formData = new FormData(form);
  var originalHTML = btn.innerHTML;

  btn.disabled = true;
  btn.innerHTML = '<span style="font-size:0.75rem">Agregando...</span>';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: formData
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(err) { throw err; });
    return r.json();
  })
  .then(function(item) {
    /* Mostrar exito en el boton */
    btn.classList.add('pce-card__atc-btn--success');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

    /* 1. Obtener cantidad del carrito */
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        /* 2. Actualizar bubble */
        pceUpdateBubble(cart.item_count);

        /* 3. Refrescar contenido del drawer */
        return pceRefreshDrawer();
      });
  })
  .then(function() {
    /* Restaurar boton */
    setTimeout(function() {
      btn.classList.remove('pce-card__atc-btn--success');
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    }, 1200);
  })
  .catch(function(error) {
    var msg = (error && error.description) ? error.description : 'Error';
    btn.innerHTML = '<span style="font-size:0.7rem">' + msg + '</span>';
    setTimeout(function() {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    }, 2000);
  });
});
/* Fix carrusel - detener propagacion de clics en controles */
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    var el = e.target.closest('.pce-card__variant-select, .pce-card__qty-btn, .pce-card__qty-input, .pce-card__atc-btn');
    if (el && el.closest('slideshow-slide')) {
      e.stopPropagation();
    }
  }, true);
  document.addEventListener('mousedown', function(e) {
    var el = e.target.closest('.pce-card__variant-select, .pce-card__qty-btn, .pce-card__qty-input, .pce-card__atc-btn, .pce-card__form');
    if (el && el.closest('slideshow-slide')) {
      e.stopPropagation();
    }
  }, true);
  document.addEventListener('pointerdown', function(e) {
    var el = e.target.closest('.pce-card__variant-select, .pce-card__qty-btn, .pce-card__qty-input, .pce-card__atc-btn, .pce-card__form');
    if (el && el.closest('slideshow-slide')) {
      e.stopPropagation();
    }
  }, true);
});